import { call, put, takeEvery, all, fork } from "redux-saga/effects";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PropTypes from "prop-types";
import { useTranslation, withTranslation } from "react-i18next";

// Evenement Redux States
import {
  GET_EVENEMENTS,
  ADD_NEW_EVENEMENT,
  UPDATE_EVENEMENT,
} from "./actionType";

import {
  evenementApiResponseSuccess,
  evenementApiResponseError,
  addEvenementFail,
  addEvenementSuccess,
  updateEvenementSuccess,
  updateEvenementFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  getEvenements as getEvenementsApi,
  addNewEvenement,
  updateEvenement,
} from "../../helpers/fakebackend_helper";

function* getEvenements() {
  try {
    const response = yield call(getEvenementsApi);
    yield put(evenementApiResponseSuccess(GET_EVENEMENTS, response));
  } catch (error) {
    yield put(evenementApiResponseError(GET_EVENEMENTS, error));
  }
}

function* onUpdateEvenement({ payload: evenement }) {
  console.log(evenement);
  try {
    const response = yield call(updateEvenement, evenement);
    console.log(response);
    yield put(updateEvenementSuccess(response));
  } catch (error) {
    console.log(error);
    yield put(updateEvenementFail(error));
  }
}

function* onAddNewEvenement({ payload: evenement }) {
  try {
    console.log("evenement: ", evenement);
    const response = yield call(addNewEvenement, evenement);
    yield put(addEvenementSuccess(response));
  } catch (error) {
    yield put(addEvenementFail(error));
  }
}

export function* watchGetEvenements() {
  yield takeEvery(GET_EVENEMENTS, getEvenements);
}

export function* watchUpdateEvenement() {
  yield takeEvery(UPDATE_EVENEMENT, onUpdateEvenement);
}

export function* watchAddNewEvenement() {
  yield takeEvery(ADD_NEW_EVENEMENT, onAddNewEvenement);
}

function* evenementSaga() {
  yield all([
    fork(watchGetEvenements),
    fork(watchUpdateEvenement),
    fork(watchAddNewEvenement),
  ]);
}

export default evenementSaga;
